import { LocalStorage } from '../utilities/localStorage';
import axios from '../services/axios';

export const useContent = () => {
  const content = JSON.parse(LocalStorage.get('content-string') || '{}');

  return (key: string) => {
    if (content === null) {
      return key;
    }
    if (content) {
      return content?.find((item: any) => item.strKey === key)?.strValue ?? null;
    }
  };
};



export const useVis = () => {
  const content = JSON.parse(LocalStorage.get('content-string') || '{}');

  return (key: string) => {
    if (content === null) {
      return key;
    }
    if (content) {
      return content?.find((item: any) => item.strKey === key)?.clientContent ?? null;
    }
  };
};


export const loadContent = (): Promise<void> => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/content-string/client`, {
      skipAutoCancel: true,
    })
    .then((res) => {
      LocalStorage.set('content-string', JSON.stringify(res.data));
    })
    .catch((error) => {
      console.error('İçerik yüklenirken hata oluştu:', error);
      throw error;
    });
};

export default useContent;
